<template>
  <div>
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="String(id)"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
    />
  </div>
</template>
<script>
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
export default {
  data () {
    return {
      component: {
        class: 'col-12 mt-3',
        componentName: 'LmFormSeparator',
        componentProps: {
          isVisible: true
        }
      }
    }
  },
  components: {
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    id: {
      type: [String, Number],
      default: ''
    },
    componentData: {
      type: Object,
      default: () => (
        {
          id: '',
          class: 'col-12 mt-3',
          componentName: 'LmFormSeparator',
          componentProps: {
            isVisible: true
          }
        }
      )
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  created () {
    this.component = this.componentData
    this.$emit('input', this.component)
  }
}
</script>
